import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/pagelayout';
import './notFound.css';

export default function NotFound() {
  return (
    <PageLayout>
      <div className="notFoundPage">
        <h1>404</h1>

        <h2>
          “Not all who wander are lost”
          <br />
          But this page definitely is.
        </h2>

        <p>We couldn't find the page you're looking for</p>

        <Link to="/Home" className="notFoundBtn">Back to Home
        </Link>
      </div>
    </PageLayout>
  );
}